import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import OpenedFormName from "components/ProjectSpecificComponents/Elements/Navigation/molecules/OpenedFormName"
import PTKMSideNav from "components/ProjectSpecificComponents/Elements/Navigation/organisms/PTKMSideNav"
import RequestSideNav from "components/ProjectSpecificComponents/Elements/Navigation/organisms/RequestSideNav"
import { observer } from "mobx-react-lite"
import { storeAnnotation } from "mobx/dist/internal"
import React, { useEffect, useState } from "react"

interface Props {
	type: "PTKM" | "REQUEST"
}

const AdminTemplateLeftPanel = observer(({ type }: Props) => {
	const { isMobile, isSmallTablet } = useScreenType()
	const isCompactView = isMobile || isSmallTablet
	const store = useStore()
	const [isMounted, setMounted] = useState<boolean>(false)

	useEffect(() => {
		// Used to refresh UI after to get newest section referances
		setMounted(true)
		return () => {
			setMounted(false)
		}
	}, [])

	return (
		<HyperDiv
			width={isCompactView ? 100 : "17vw"}
			style={{ maxWidth: 270 }}
			direction="column"
			centered
		>
			<Whitespace x="2" />
			<OpenedFormName />
			<Whitespace x="1.5" />
			{isMounted && (
				<HyperDiv width="100%">
					{type === "REQUEST" && <RequestSideNav textHidden={isCompactView} />}
					{type === "PTKM" && <PTKMSideNav textHidden={isCompactView} />}
				</HyperDiv>
			)}
		</HyperDiv>
	)
})

export default AdminTemplateLeftPanel
